import { FC } from 'react'
import cx from 'classnames'

import { LexiconItemProps } from '../Item'

import * as SC from './styled'

export type LexiconLetterProps = MinimalSeoBlock & {
  className?: string
  id?: string
  letter: string
  items: LexiconItemProps[]
}

const LexiconLetter: FC<LexiconLetterProps> = ({
  className,
  id,
  letter,
  items,
  htmlTag,
  htmlTitleTag,
}) => {
  return (
    <SC.Container
      className={cx('LexiconLetter', className)}
      id={id}
      as={htmlTag}
    >
      <SC.Title as={htmlTitleTag}>{letter}</SC.Title>
      <SC.Items>
        {items.map((item, index) => (
          <SC._LexiconItem
            key={index}
            {...item}
            htmlTag="div"
            htmlTitleTag="dt"
            htmlDefinitionTag="dd"
          />
        ))}
      </SC.Items>
    </SC.Container>
  )
}

export default LexiconLetter
